import React, { useState } from "react";
import toast from "react-hot-toast";
import styles from "./ForgotPassword.module.css";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/Sankrutilogo.jpeg";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message);
        setStep(2);
      } else {
        toast.error(data.message || "Email not found");
      }
    } catch (error) {
      toast.error("Failed to connect to server");
    } finally {
      setLoading(false);
    }
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp, newPassword }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Password reset successfully!");
        navigate("/login");
      } else {
        toast.error(data.message || "Failed to reset password");
      }
    } catch (error) {
      toast.error("Failed to connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      {/* Background decorations matching the image */}
      <div className={styles.bgLeavesTopRight}></div>
      <div className={styles.bgLeavesBottomLeft}></div>

      <div className={styles.loginCard}>
        {/* Logo Section */}
        <div className={styles.logoContainer}>
          <img src={logo} alt="Sanskruti Shubhangan" className={styles.logo} />
        </div>

        <div className={styles.cardHeader}>
          <h2 className={styles.title}>Forgot Password</h2>
          <p className={styles.subtitle}>
            {step === 1 ? "Enter your email to receive an OTP" : "Enter OTP and your new password"}
          </p>
        </div>

        {step === 1 ? (
          <form className={styles.loginForm} onSubmit={handleEmailSubmit}>
            <div className={styles.formGroup}>
              <label>Email Address</label>
              <div className={styles.inputWrapper}>
                <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" strokeWidth="1.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                <input 
                  type="email" 
                  placeholder="Enter email address" 
                  className={styles.inputField} 
                  required 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                />
              </div>
            </div>

            <button className={styles.submitBtn} disabled={loading}>
              {loading ? "Please wait..." : "Send OTP"}
            </button>
          </form>
        ) : (
          <form className={styles.loginForm} onSubmit={handleResetSubmit}>
            <div className={styles.formGroup}>
              <label>OTP (Demo Use: 123456)</label>
              <div className={styles.inputWrapper}>
                <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" strokeWidth="1.5"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path></svg>
                <input 
                  type="text" 
                  placeholder="Enter OTP" 
                  className={styles.inputField} 
                  required 
                  value={otp} 
                  onChange={(e) => setOtp(e.target.value)} 
                />
              </div>
            </div>

            <div className={styles.formGroup}>
              <label>New Password</label>
              <div className={styles.inputWrapper}>
                <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                <input 
                  type="password" 
                  placeholder="Enter new password" 
                  className={styles.inputField} 
                  required 
                  value={newPassword} 
                  onChange={(e) => setNewPassword(e.target.value)} 
                />
              </div>
            </div>

            <button className={styles.submitBtn} disabled={loading}>
              {loading ? "Please wait..." : "Reset Password"}
            </button>
          </form>
        )}

        <div className={styles.switchAuth}>
          <p>Remember your password? <Link to="/login"><span style={{ marginLeft: 0 }}>Login Now <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></span></Link></p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
